import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.selected_attributes"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "ml-md-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: {
                      click: function ($event) {
                        return _vm.cleanSelection()
                      },
                    },
                  },
                  [
                    _c(VIcon, [_vm._v("mdi-playlist-remove")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("attributes.button.clean_selection")) +
                        " "
                    ),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-md-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: {
                      click: function ($event) {
                        return _vm.registerGroup(_vm.DIALOG_ADD_GROUP_ATTRIBUTE)
                      },
                    },
                  },
                  [
                    _c(VIcon, [_vm._v("mdi-content-save-all")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("attributes.button.register_selection")) +
                        " "
                    ),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onEnableFilter },
                  },
                  [
                    _vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-off-outline"),
                        ])
                      : _vm._e(),
                    !_vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-outline"),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            _c(
              VCard,
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _vm._l(
                      Object.entries(_vm.partitionsByTable),
                      function (ref) {
                        var key = ref[0]
                        var value = ref[1]
                        return _c(
                          "div",
                          {
                            key: key,
                            staticClass: "form-row row--dense pt-3 pl-3 pr-3",
                          },
                          [
                            _c(VCol, { attrs: { cols: "4" } }, [
                              _c("label", [_vm._v(_vm._s(key))]),
                            ]),
                            _c(
                              VCol,
                              { attrs: { cols: "8" } },
                              [
                                _c(VSelect, {
                                  staticClass: "select-periods",
                                  attrs: {
                                    label: "Periodo",
                                    type: "text",
                                    name: _vm.partitionsByTable[key].selection,
                                    items: _vm.partitionsByTable[key].values,
                                    "item-value": "id",
                                    "item-text": "name",
                                    multiple: "",
                                    "persistent-hint": "",
                                    rules: _vm.partitionsByTable[key].values
                                      ? _vm.rules.period
                                      : [],
                                    "prepend-icon": "mdi-calendar",
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChangePartitions(key)
                                    },
                                  },
                                  model: {
                                    value: _vm.partitionsByTable[key].selection,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.partitionsByTable[key],
                                        "selection",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "partitionsByTable[key].selection",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    _c(VDataTable, {
                      key: _vm.keyTable,
                      staticClass: "text-center table-inca",
                      attrs: {
                        responsive: "",
                        items: _vm.items,
                        headers: _vm.headers,
                        "group-by": "categoria",
                        search: _vm.search,
                        "hide-default-footer": "",
                        "items-per-page": _vm.pagination.limit,
                        page: _vm.pagination.current,
                      },
                      on: {
                        pagination: function ($event) {
                          _vm.pagination.total = $event.itemsLength
                        },
                        "update:page": function ($event) {
                          return _vm.$set(_vm.pagination, "current", $event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.no_nulo",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.no_nulo === -1
                                      ? "-"
                                      : Math.round(item.no_nulo) + "%"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(VHover, {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            VIcon,
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                medium: "",
                                                color: hover
                                                  ? "#F03063"
                                                  : "#0021CF",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeItem(item)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    hover
                                                      ? "mdi-minus-circle-outline"
                                                      : "mdi-check-circle-outline"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.not_null",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatPercentage")(item.not_null)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "text-left mt-3 pb-2" },
                  [
                    _c("pagination-vue", {
                      attrs: { pagination: _vm.pagination },
                    }),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { staticClass: "pr-md-2 pb-md-2" },
                  [
                    _c(
                      VCol,
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          VBtn,
                          {
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "/attributes/search/list"
                                )
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { right: "" } }, [
                              _vm._v("icon-search"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("attributes.search.search")) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary ml-md-1",
                            on: {
                              click: function ($event) {
                                return _vm.goToWizard()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("attributes.sandbox.request_title")
                                ) +
                                " "
                            ),
                            _c(VIcon, { attrs: { right: "" } }, [
                              _vm._v("mdi-chevron-right"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(" " + _vm._s(_vm.$t("titles.filters")) + " "),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    label: "Categoría",
                                    multiple: "",
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.categories,
                                  },
                                  on: { change: _vm.changeFilter },
                                  model: {
                                    value: _vm.filtro.categoria,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filtro, "categoria", $$v)
                                    },
                                    expression: "filtro.categoria",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    label: "Tipo",
                                    multiple: "",
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.dataTypes,
                                  },
                                  on: { change: _vm.changeFilter },
                                  model: {
                                    value: _vm.filtro.tipo_dato,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filtro, "tipo_dato", $$v)
                                    },
                                    expression: "filtro.tipo_dato",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSwitch, {
                                  attrs: { label: "% no nulo sin valor" },
                                  on: { change: _vm.changeFilter },
                                  model: {
                                    value: _vm.filtro.sin_valor,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filtro, "sin_valor", $$v)
                                    },
                                    expression: "filtro.sin_valor",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VRangeSlider, {
                                  staticClass: "align-center pb-3",
                                  attrs: {
                                    max: _vm.slider.max,
                                    min: _vm.slider.min,
                                    "hide-details": "",
                                  },
                                  on: { change: _vm.changeFilter },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "prepend",
                                        fn: function () {
                                          return [
                                            _c(VTextField, {
                                              staticClass: "mt-0 pt-0",
                                              staticStyle: { width: "60px" },
                                              attrs: {
                                                value: _vm.slider.range[0],
                                                "hide-details": "",
                                                "single-line": "",
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.slider.range,
                                                    0,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(VTextField, {
                                              staticClass: "mt-0 pt-0",
                                              staticStyle: { width: "60px" },
                                              attrs: {
                                                value: _vm.slider.range[1],
                                                "hide-details": "",
                                                "single-line": "",
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.slider.range,
                                                    1,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    300091295
                                  ),
                                  model: {
                                    value: _vm.slider.range,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.slider, "range", $$v)
                                    },
                                    expression: "slider.range",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_GROUP_ATTRIBUTE,
        attrs: {
          title: _vm.$t("titles.add_attributes"),
          "show-buttons": false,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("add-attribute-group-component", {
                      attrs: { item: _vm.items },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "MODAL_CONFIRM_CLEAN_SELECTION",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de limpiar toda la lista?",
        },
        on: { onConfirm: _vm.onConfirmClean },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }